import { NumberPatternType, resolveDeclensionTranslationKey, TranslatableText } from '@dreryk/react-common';
import { InteractiveTable, useInteractiveTableContext } from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../../translations';
import {
   CONFIDENTIALITY_ACCESS_DURATION_MAX_HOURS,
   CONFIDENTIALITY_ACCESS_DURATION_MIN_HOURS,
} from '../../ConfidentialitySettings.types';
import { ConfidentialityEditModalRow } from '../ConfidentialityEditModal.types';

const t = generalSettingsTranslationKeys.confidentialitySettings;

type AccessDurationCellProps = {
   index: number;
   defaultValue: number | null;
   rangeValidationMessage: TranslatableText;
};

export const AccessDurationCell = (props: AccessDurationCellProps): JSX.Element => {
   const { getCellValue } = useInteractiveTableContext<ConfidentialityEditModalRow>();

   const currentValue = getCellValue('accessDurationHours', props.index) ?? props.defaultValue ?? 0;

   const unitSuffix = resolveDeclensionTranslationKey(
      Number(currentValue),
      t.hoursDeclensionMap.accusative,
      t.hoursDeclensionMap.genitive,
      t.hoursDeclensionMap.plural
   );

   return (
      <InteractiveTable.NumberInputCell
         testId={'accessDurationHours'}
         name={'accessDurationHours'}
         index={props.index}
         defaultValue={props.defaultValue}
         validationRules={{
            required: true,
            min: { value: CONFIDENTIALITY_ACCESS_DURATION_MIN_HOURS, message: props.rangeValidationMessage },
            max: { value: CONFIDENTIALITY_ACCESS_DURATION_MAX_HOURS, message: props.rangeValidationMessage },
         }}
         pattern={NumberPatternType.POSITIVE_INTEGER}
         min={CONFIDENTIALITY_ACCESS_DURATION_MIN_HOURS}
         max={CONFIDENTIALITY_ACCESS_DURATION_MAX_HOURS}
         stepValue={1}
         enableControlButtons
         suffix={unitSuffix}
      />
   );
};
